import React from "react";

//MUI
import SvgIcon from '@mui/material/SvgIcon';

//Types
import { SvgIconProps } from "@mui/material";

function ToolCommentIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
  <svg version="1.1" id="Layer_1" fill="currentcolor" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100px" height="100px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100" xmlSpace="preserve">
  <path d="M87.65,16.35c-1.567-1.566-3.45-2.35-5.649-2.35H18c-2.201,0-4.085,0.784-5.651,2.35c-1.567,1.567-2.35,3.45-2.35,5.649V70
    c0,2.2,0.782,4.085,2.35,5.651C13.916,77.217,15.799,78,18,78h56l16,16V21.999C90,19.799,89.216,17.917,87.65,16.35z M82.001,74.5
    l-4.6-4.5H18V21.999h64.001V74.5z"/>
  <circle cx="30.17" cy="46" r="5.5"/>
  <circle cx="50.001" cy="46" r="5.5"/>
  <circle cx="70.213" cy="46" r="5.5"/>
  </svg>


  </SvgIcon>
}

export default ToolCommentIcon;
